import { useMemo } from 'react';
import { Module } from 'src/domain';
import { useChainFurnitureZoneQuery } from 'src/hooks/chain-furniture-zone/queries/useChainFurnitureZoneQuery';
import { useInventoryMasterDataQuery } from 'src/hooks/inventory-master-data/queries/useInventoryMasterDataQuery';
import { useStoreInventorySimulationRows } from 'src/hooks/store-inventory-management/table/useStoreInventorySimulationRows';
import { useStyleTimelineQuery } from 'src/hooks/style-timeline/queries/useStyleTimelineQuery';
import { useModulePlanningRange } from 'src/hooks/useModulePlanningRange';
import {
    HeatMapTypeEnum,
    mapStyleTimelineDataToProjectedOptionCountHeatMapRows,
} from 'src/mapping/projected-option-count.mapping';

export const useProjectedOptionCountHeatMapRows = (type: HeatMapTypeEnum) => {
    const { styleTimelines, styleCategories, loading, error } = useStyleTimelineQuery();
    const { data: furnitures } = useInventoryMasterDataQuery();
    const { data: zones } = useChainFurnitureZoneQuery();
    const { data: storeInventory } = useStoreInventorySimulationRows();
    const planningRange = useModulePlanningRange(Module.ProjectedOptionCount);

    const { rows } = useMemo(() => {
        if (!styleTimelines || !styleCategories || !furnitures || !zones || !storeInventory) return { rows: [] };

        return mapStyleTimelineDataToProjectedOptionCountHeatMapRows({
            styleTimelineData: styleTimelines,
            styleCategories,
            type,
            planningRange,
            furnitures,
            zones,
        });
    }, [styleTimelines, styleCategories, type, planningRange, furnitures, zones, storeInventory]);

    return { data: rows, loading, error };
};
